import type { ControllerRenderProps, FieldValues, Path } from "react-hook-form";
import {
  FormControl,
  FormDescription,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/base/form/hook-form";
import {
  TextArea,
  type TextFieldProps,
} from "@/components/base/textarea/textarea";

export type FormTextAreaFieldProps<
  TFieldValues extends FieldValues = FieldValues,
> = {
  field: ControllerRenderProps<TFieldValues, Path<TFieldValues>>;
  label?: string;
  labelClasses?: string;
  inputClasses?: string;
  description?: string;
  className?: string;
} & TextFieldProps;

export const FormTextAreaField = <
  TFieldValues extends FieldValues = FieldValues,
>({
  label,
  labelClasses,
  description,
  isRequired,
  field,
  className,
  inputClasses,
  ...props
}: FormTextAreaFieldProps<TFieldValues>) => {
  return (
    <FormItem className={className}>
      <FormLabel className={labelClasses} required={isRequired}>
        {label}
      </FormLabel>
      <FormControl>
        <TextArea
          {...props}
          {...field}
          aria-label={label}
          className={inputClasses}
          isRequired={isRequired}
        />
      </FormControl>
      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  );
};

FormTextAreaField.displayName = "FormTextAreaField";
